import axios from '../../../boot/axios';
import { buildFetchUrl } from "../../../helpers/url";

export default {
    
    getMyStrategies(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/getMyStrategies', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    deleteMyStrategy(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/deleteMyStrategy', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    setPlayStrategy(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/setPlayStrategy', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    setAutoStrategy(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/setAutoStrategy', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    setBetfairStrategy(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/setBetfairStrategy', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    getMyStrategies_(_) {
        return new Promise((resolve, reject) => {
            axios.get('api/v1/getFeeds')
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err));
        });
    },

    placeOrders(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/placeOrders', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },

    betfairCashout(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/betfairCashout', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },

    deleteOrder(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/deleteOrder', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },

    updateOrder(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/updateOrder', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },

    setStrategyView(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/setStrategyView', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    setTipView(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/setTipView', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    resetStrategyStats(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/resetStrategyStats', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    getBetfairTips(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/getBetfairTips', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    getBetfairHistory_date(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/getBetfairHistory_date', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    getMarketData(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/getMarketData', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    getBetfairHistoryDate(_) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/getBetfairHistoryDate')
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
}